import React, { Component } from "react";
import Header from "./Header";
import Footer from "./Footer";
import HeaderIntroLoans from "./HeaderIntroLoans";
export class PersonalLoan extends Component {
  render() {
    return (
      <div>
        <Header />
        <div>
          <HeaderIntroLoans />
        </div>

        <section id="about">
          <div class="container" data-aos="fade-up">
            <header class="section-header">
              <h3>PERSONAL LOANS </h3>
              <p>
                Need quick cash for an unexpected financial emergency? Turn to
                our Personal Loans to cover your immediate financial
                requirements. We help provide Personal Loans for a variety of
                reasons including wedding, education, home renovation, travel or
                even medical needs. With interest rates starting at 10.99 % and
                tenure up to 72 months, you can find all your desires within
                reach.   With our Personal Loans, you can borrow up to Rs.25
                lakh and get instant approval on it with minimal documentation.
                Fulfil our easy-to-meet eligibility parameters and basic
                documentation process to avail the money you need within the
                same day of approval.
              </p>
            </header>
          </div>
        </section>

        <section id="why-us">
          <div class="container" data-aos="fade-up">
            <header class="section-header">
              <h3>HOW IT WORKS?</h3>
              {/* <p>
                Any business offering sale of goods with annual turn over of 40
                lacs or service with annual turn over of 20 lacs would require
                the registration for GST and have a valid GST Number.
              </p> */}
            </header>

            <div class="row row-eq-height justify-content-center">
              <div class="col-lg-4 mb-4">
                <div class="card" data-aos="zoom-in" data-aos-delay="100">
                  <i class="fa fa-diamond"></i>
                  <div class="card-body">
                    <h5 class="card-title">Step 1:</h5>
                    <p class="card-text">
                      Quick Register : Fill up a Simple Form
                    </p>
                    <a href="#" class="readmore">
                      Read more{" "}
                    </a>
                  </div>
                </div>
              </div>

              <div class="col-lg-4 mb-4">
                <div class="card" data-aos="zoom-in" data-aos-delay="200">
                  <i class="fa fa-language"></i>
                  <div class="card-body">
                    <h5 class="card-title">Step 2:</h5>
                    <p class="card-text">
                      Select From Multiple Offers : List of Offers from Multiple
                      Banks
                    </p>
                    <a href="#" class="readmore">
                      Read more{" "}
                    </a>
                  </div>
                </div>
              </div>

              <div class="col-lg-4 mb-4">
                <div class="card" data-aos="zoom-in" data-aos-delay="300">
                  <i class="fa fa-object-group"></i>
                  <div class="card-body">
                    <h5 class="card-title">Step 3:</h5>
                    <p class="card-text">
                      Apply : Quick Application in less than 15 mins{" "}
                    </p>
                    <a href="#" class="readmore">
                      Read more{" "}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section id="services" class="section-bg">
          <div class="container" data-aos="fade-up">
            <header class="section-header">
              <h3>BENEFITS AND FEATURES OF PERSONAL LOANS</h3>
              <br />
              {/* <p>
                At ClipTax, we ensure a smooth entry for you in market, while
                guiding and assisting you through the complex procedures of
                Business Registration. Our focus is on simplifying toilsome
                procedures for incorporation of your business so that you can
                purely concentrate on your business intent. You dream, Cliptax
                executes!
              </p> */}
            </header>

            <div class="row justify-content-center">
              <div
                class="col-md-6 col-lg-5"
                data-aos="zoom-in"
                data-aos-delay="100"
              >
                <div class="box">
                  <div class="icon">
                    <i
                      class="ion-ios-analytics-outline"
                      style={{ color: "#ff689b" }}
                    ></i>
                  </div>
                  <h4 class="title">
                    <a href="">No Collateral Required</a>
                  </h4>
                  <p class="description">
                    One of the benefits associated with an online personal loan
                    is that it is unsecured in nature. This means you don’t need
                    to pledge any collateral for your loan. Although this can be
                    a reason for your interest rate, you can get a low-interest
                    personal loan easily if you meet the eligibility
                    requirements.
                  </p>
                </div>
              </div>
              <div
                class="col-md-6 col-lg-5"
                data-aos="zoom-in"
                data-aos-delay="200"
              >
                <div class="box">
                  <div class="icon">
                    <i
                      class="ion-ios-bookmarks-outline"
                      style={{ color: "#e9bf06" }}
                    ></i>
                  </div>
                  <h4 class="title">
                    <a href="">Minimal Documentation</a>
                  </h4>
                  <p class="description">
                    In this age of digitization, the process of verification and
                    documentation has now become short. This is applicable for
                    an instant personal loan as they are fast in disbursal and
                    require minimum documents for approval.
                  </p>
                </div>
              </div>

              <div
                class="col-md-6 col-lg-5"
                data-aos="zoom-in"
                data-aos-delay="100"
              >
                <div class="box">
                  <div class="icon">
                    <i
                      class="ion-ios-paper-outline"
                      style={{ color: "#3fcdc7" }}
                    ></i>
                  </div>
                  <h4 class="title">
                    <a href="">Easy Approval</a>
                  </h4>
                  <p class="description">
                    You can get personal loans that are quick and easy in
                    approval. This is why it is the best bet in times of
                    financial emergency. Moreover, the process has become
                    digital; thus reducing time in the verification process.
                  </p>
                </div>
              </div>
              <div
                class="col-md-6 col-lg-5"
                data-aos="zoom-in"
                data-aos-delay="200"
              >
                <div class="box">
                  <div class="icon">
                    <i
                      class="ion-ios-speedometer-outline"
                      style={{ color: "#41cf2e" }}
                    ></i>
                  </div>
                  <h4 class="title">
                    <a href="">Multipurpose In Nature</a>
                  </h4>
                  <p class="description">
                    Personal loans are multi-purpose loans that can be used for
                    funding various expenses as per the borrower’s discretion,
                    from unexpected expenses to major life events such as a
                    wedding.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section id="services" class="section-bg">
          <div class="container" data-aos="fade-up">
            <header class="section-header">
              <h3>DOCUMENTS REQUIRED FOR PERSONAL LOAN</h3>
              <br />
              {/* <p>
                At ClipTax, we ensure a smooth entry for you in market, while
                guiding and assisting you through the complex procedures of
                Business Registration. Our focus is on simplifying toilsome
                procedures for incorporation of your business so that you can
                purely concentrate on your business intent. You dream, Cliptax
                executes!
              </p> */}
            </header>

            <div class="row justify-content-center">
              <div
                class="col-md-6 col-lg-5"
                data-aos="zoom-in"
                data-aos-delay="100"
              >
                <div class="box">
                  <div class="icon">
                    <i
                      class="ion-ios-analytics-outline"
                      style={{ color: "#ff689b" }}
                    ></i>
                  </div>
                  <h4 class="title">
                    <a href="">Photo Identity Proof</a>
                  </h4>
                  <p class="description">
                   A copy of your Voter ID/ Passport/ Driving License/ Aadhar Card
                  </p>
                </div>
              </div>
              <div
                class="col-md-6 col-lg-5"
                data-aos="zoom-in"
                data-aos-delay="200"
              >
                <div class="box">
                  <div class="icon">
                    <i
                      class="ion-ios-bookmarks-outline"
                      style={{ color: "#e9bf06" }}
                    ></i>
                  </div>
                  <h4 class="title">
                    <a href="">Income Proof</a>
                  </h4>
                  <p class="description">
                   A copy of your Bank statements for the last six months 
                  </p>
                </div>
              </div>

              <div
                class="col-md-6 col-lg-5"
                data-aos="zoom-in"
                data-aos-delay="100"
              >
                <div class="box">
                  <div class="icon">
                    <i
                      class="ion-ios-paper-outline"
                      style={{ color: "#3fcdc7" }}
                    ></i>
                  </div>
                  <h4 class="title">
                    <a href="">Salary Slips</a>
                  </h4>
                  <p class="description">
                    A copy of your Salary Slips for the last three months
                  </p>
                </div>
              </div>
              <div
                class="col-md-6 col-lg-5"
                data-aos="zoom-in"
                data-aos-delay="200"
              >
                <div class="box">
                  <div class="icon">
                    <i
                      class="ion-ios-speedometer-outline"
                      style={{ color: "#41cf2e" }}
                    ></i>
                  </div>
                  <h4 class="title">
                    <a href="">Address Proof</a>
                  </h4>
                  <p class="description">
                    A copy of your Ration Card / Electricity Bill / Passport
                  </p>
                </div>
              </div>

              <div
                class="col-md-6 col-lg-5"
                data-aos="zoom-in"
                data-aos-delay="200"
              >
                <div class="box">
                  <div class="icon">
                    <i
                      class="ion-ios-speedometer-outline"
                      style={{ color: "#41cf2e" }}
                    ></i>
                  </div>
                  <h4 class="title">
                    <a href="">Employment Certificate</a>
                  </h4>
                  <p class="description">
                    A certificate stating one year of continuos employment
                  </p>
                </div>
              </div>
              
            </div>


          </div>

          
        </section>
        <Footer />
      </div>
    );
  }
}

export default PersonalLoan;
